import { EuiFlexGroup, EuiFlexItem, EuiPanel } from '@elastic/eui';
import React, { useMemo } from 'react';
import { MaskLoad } from '../../../../components/Layout';
import { FilterComponent } from '../FilterComponent';
import { GridResultsScreen } from '../Grid/GridResultsScreen';


export const SociedadDetalleScreen = (props:any) =>{
    
    const {dataFilter, onVisualizarFacturacion, onGenerarFactura, data, isLoading, user, translate, rolPermiso, showFacturacion,onFacturaAs400} = props;

    // const RolPermiso = useMemo(()=> (dataFilter && getPermisoExpatriados(dataFilter.rolPermiso)),[dataFilter])

    // const showFacturacion = useMemo(()=>user && (user.perfil===PERFIL_ADMIN || RolPermiso.value === ROLES_EXPATRIADOS.ADMINISTRADOR.value)
    // ,[user,RolPermiso])

    const onClickVisualizarFacturacion = (requestFilter:any,soloVisualizar:boolean) =>{
        onVisualizarFacturacion(requestFilter, rolPermiso.value)
    }

    const onClickGenerarFactura = (requestFilter:any) =>{
        onGenerarFactura({...requestFilter,...{tipoAgrupacion:1}}, rolPermiso.value)
    }

    const onClickFacturaAs400 = (idFactura:string, tipoSociedad:string) =>{
        onFacturaAs400(idFactura,tipoSociedad)
    }
    

    const getCodigoEmpresa = useMemo(()=> (dataFilter && dataFilter.idSociedad) ?
        (<EuiFlexItem grow={false} className='detalle-facturacion-expatriado-header'>
            {`${translate('codigo')}: ${dataFilter && dataFilter.idSociedad}`}
        </EuiFlexItem>) : null
    ,[dataFilter])

    const getEmpresa = useMemo(()=> (dataFilter && dataFilter.sociedad) ?
        (<EuiFlexItem grow={false} className='detalle-facturacion-expatriado-header'>
            {`${translate('empresa')}: ${dataFilter && dataFilter.sociedad.toLowerCase()}`}
        </EuiFlexItem>) : null
    ,[dataFilter])

    const getReferencia = useMemo(()=> (dataFilter.referencia) ?
    (<EuiFlexItem grow={false} className='detalle-facturacion-expatriado-header'>
        {`${translate('referencia')}: ${dataFilter.referencia}`}
    </EuiFlexItem>) : null
    ,[dataFilter])

    const getGrupoFactura = useMemo(()=> (dataFilter.grupoFactura) ?
    (<EuiFlexItem grow={false} className='detalle-facturacion-expatriado-header'>
        {`${translate('grupo')}: ${dataFilter.grupoFactura}`}
    </EuiFlexItem>) : null
    ,[dataFilter])

    const cabecera = (
        <EuiFlexGroup className='detalle-facturacion-expatriado-content-header' justifyContent='flexEnd'>
            <EuiFlexItem grow={false} className='detalle-facturacion-expatriado-header rol'>{`${translate('mi-rol')}: ${rolPermiso.label}`}</EuiFlexItem>
            <EuiFlexItem>
                <EuiFlexGroup justifyContent='flexEnd'>
                    {getCodigoEmpresa}
                    {getEmpresa}
                    {getReferencia}
                    {getGrupoFactura}
                </EuiFlexGroup>
            </EuiFlexItem>        
        </EuiFlexGroup>
    )

    const Mask = useMemo(()=>{return (<MaskLoad isLoading={isLoading.stateLoad} 
        text={ translate(isLoading.type == 'v' ? "msg-loading-visualizar-factura" : "msg-loading-procesar-factura")}/>)}
    ,[isLoading])

    const AgrupacionData = useMemo(()=>{ return dataFilter && {tipoAgrupacion:'Sociedad',agrupacionDestinoFactura:dataFilter.idSociedad}},[dataFilter])
    
    return (
        <>
        <EuiFlexGroup direction='column'>
            <EuiFlexItem grow={false}>{cabecera}</EuiFlexItem>
            {showFacturacion ?
                <EuiFlexItem grow={false}>
                    <EuiPanel style={{marginLeft:'2rem',marginRight:'2rem'}}>
                        <EuiFlexGroup direction='column'>
                            <EuiFlexItem className='titulo-facturacion-expatriados'><h2>{translate('facturacion')}</h2></EuiFlexItem>
                            <EuiFlexItem>
                            <FilterComponent tipo={1} dataFilter={dataFilter} user={user}
                            onClickVisualizarFactura={onClickVisualizarFacturacion} onGenerarFactura={onClickGenerarFactura} 
                            dataHistorico={data.length} translate={translate} onFacturaAs400={onClickFacturaAs400}/>
                            </EuiFlexItem>
                        </EuiFlexGroup>
                    </EuiPanel>
                </EuiFlexItem>  
            : null}
            <EuiFlexItem grow={false}>
                <EuiPanel style={{marginLeft:'2rem',marginRight:'2rem'}}>
                    <EuiFlexGroup direction='column'>
                        <EuiFlexItem><h2>{translate('historicos').toUpperCase()}</h2></EuiFlexItem>
                        <EuiFlexItem>
                            <GridResultsScreen data={data} agrupacionData={AgrupacionData} rolPermiso={rolPermiso.value} large={!showFacturacion}/>
                        </EuiFlexItem>
                    </EuiFlexGroup>
                </EuiPanel>
            </EuiFlexItem>
        </EuiFlexGroup>
        {Mask}
        </>
    )
}